import styled from "styled-components";

export const Wrapper = styled.section`
  padding: 10px 16px;
  gap: 32px;
  position: relative;

  @media (min-width: 768px){
    padding: 32px 64px;
  }

  @media (min-width: 1440px) {
    padding: 48px 120px;
  }
`;

export const HeaderBar = styled.header`
  display: flex;
  align-items: center;
  gap:24px;
   max-width: 1200px;
  margin: 0 auto;

  margin-bottom: 14 px;

  @media (min-width: 992px) {
    margin-bottom: 64px;
  }

  h2{
    font-weight: 700;
    font-style: Bold;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 1px;
    text-align: center;

    @media (min-width: 850px) {
      font-weight: 700;
      font-style: Bold;
      font-size: 48px;
      line-height: 56px;
      letter-spacing: 2px;
      text-align: center;
    }
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
`;

export const Grid = styled.div`
  display: grid;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 992px) {
    grid-template-columns: 339px 1fr; /* sidebar + conteúdo */
    gap: 48px;
  }
`;

export const Sidebar = styled.aside`
  gap: 16px;
  text-align: left;
  display: flex;
  gap: 48px;
  flex-direction:column;

   @media (min-width: 992px) {
    gap:128px;
   }
 `;

export const SideBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap:16px;
  height: fit-content;

  p{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1px;
  }

  ul{
    list-style-type: disc;
    padding-left: 20px;
  }
`;

export const SideTitle = styled.h4`
  font-weight: 700;
  font-style: Bold;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 1px;
  text-align: center;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const OutlineLink = styled.a`
  display: inline-block;
  border: 1px solid rgba(106,157,255,.35);
  border-radius: 999px;
  padding: 8px 12px;
  color: #cfe0ff;
  font-size: 13px;

  &:hover {
    background: rgba(106,157,255,.10);
    color: #e9efff;
  }
`;

export const Main = styled.div`
  display: grid;
  gap: 20px;

  @media (min-width: 992px) {
    gap: 24px;
  }
`;

export const Img = styled.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: 16px;
`;

export const TwoCol = styled.div`
  display: grid;
  gap: 24px;
  
  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const Section = styled.section`
  display: grid;
  gap: 12px;

  @media (min-width: 992px) {
    gap: 14px;
  }
`;

export const SectionText = styled.p`
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1px;
  text-align: left;
`;

export const Testimonial = styled.div`
`;

export const Card = styled.article.attrs({ className: "card" })`
  padding:16px;
  background:var(--color-0a1323);
  border-radius:8px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 16px;

`;

export const Head = styled.header`
  display:flex;
  align-items:center;
  gap:8px;
`;

export const Avatar = styled.img`
  width:32px;
  height:32px;
  border-radius:50%; 
`;

export const Name = styled.div`
  font-weight: 700;
  font-style: bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
`;

export const Role = styled.div`
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;

`;

export const Text = styled.p`
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
`;

